import React from 'react'
import logoAsset from '../../Cutlio.Assets/Logo/CutlioLogo.png'

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
}

export const Logo = (props: Props) => {
  return <img {...props} alt="Cutlio Logo" src={logoAsset}/>
}